var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 404,
    viewBox: "0 0 405 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_948_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.065 0.000505333C313.024 0.244244 401.183 88.4927 401 198.129C400.817 307.857 311.665 396.365 201.691 395.999C92.3128 395.633 3.66511 306.471 4.00095 197.169C4.3368 87.7158 93.1524 -0.243233 203.065 0.000505333ZM203.019 216.47C176.976 216.379 155.299 226.388 137.606 245.155C124.142 259.429 116.036 276.308 114.906 296.036C114.448 304.11 121.959 308.619 129.515 305.511C134.385 303.516 135.652 299.463 136.66 294.726C142.583 266.909 158.169 247.654 186.487 240.22C203.493 235.756 219.751 238.194 235.001 246.785C253.396 257.144 264.143 272.972 268.066 293.598C269.776 302.586 274.875 307.324 281.317 306.273C287.652 305.237 291.377 299.204 290.263 291.801C283.714 248.553 246.786 216.684 203.019 216.47ZM122.615 123.652C107.899 123.652 96.5719 134.925 96.5719 149.564C96.5719 164.28 107.792 175.629 122.417 175.705C137.179 175.797 148.689 164.661 148.826 150.128C148.979 134.818 137.911 123.637 122.615 123.637V123.652ZM282.218 175.644C296.949 175.583 308.52 164.371 308.704 149.945C308.902 135.519 297.239 123.621 282.889 123.621C267.853 123.621 255.457 135.915 255.839 150.494C256.19 164.097 268.356 175.705 282.218 175.66V175.644Z",
    fill: "#9A9A9A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_948_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.846 217C246.47 217.214 283.277 249.073 289.804 292.307C290.915 299.709 287.217 305.739 280.888 306.775C274.467 307.826 269.385 303.09 267.68 294.104C263.785 273.485 253.073 257.662 234.723 247.306C219.523 238.717 203.318 236.28 186.368 240.742C158.158 248.174 142.607 267.423 136.704 295.231C135.699 299.968 134.436 304.018 129.583 306.013C122.036 309.12 114.549 304.597 115.021 296.541C116.147 276.82 124.227 259.946 137.647 245.676C155.282 226.93 176.888 216.924 202.846 217Z",
    fill: "#272E38"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_948_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.414 124C137.928 124 149.138 135.167 148.999 150.456C148.859 164.955 137.201 176.076 122.213 176C107.38 175.908 96.0155 164.574 96 149.893C96 135.273 107.488 124.015 122.414 124.015V124Z",
    fill: "#272E38"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_948_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.449 176C268.571 176.046 256.36 164.446 256.008 150.852C255.641 136.3 268.05 124 283.123 124C297.491 124 309.181 135.889 308.998 150.304C308.799 164.72 297.216 175.924 282.449 175.985V176Z",
    fill: "#272E38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_948_3",
    x: 0,
    y: 0,
    width: 405,
    height: 404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_948_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_948_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_948_3",
    x: 111,
    y: 217,
    width: 183,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_948_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_948_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_948_3",
    x: 92,
    y: 124,
    width: 61,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_948_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_948_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_948_3",
    x: 252,
    y: 124,
    width: 61,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_948_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_948_3",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadIcon);
export default __webpack_public_path__ + "static/media/sadIcon.8754529fb0945fff9f0c7f4789b0a2c9.svg";
export { ForwardRef as ReactComponent };